/**
 * Wave 4b: exchange a profile-pictures storage ref for a short-lived signed URL.
 * Fail-closed: signable refs return signed URL or null, never the public URL.
 */
const PUBLIC_MARKER = '/object/public/profile-pictures/'
const SIGNED_MARKER = '/object/sign/profile-pictures/'

export function isSignableProfilePictureRef(raw: string | null | undefined): boolean {
  if (!raw || typeof raw !== 'string') return false
  const v = raw.trim()
  if (!v) return false
  if (v.includes(PUBLIC_MARKER) || v.includes(SIGNED_MARKER)) return true
  if (/^https?:\/\//i.test(v)) return false
  if (v.includes('..')) return false
  return true
}

export async function resolveProfilePictureUrl(
  rawUrl: string | null | undefined
): Promise<string | null> {
  if (!rawUrl || typeof rawUrl !== 'string') return null
  const original = rawUrl.trim()
  if (!original) return null
  if (!isSignableProfilePictureRef(original)) return original

  try {
    const response = await fetch('/api/public/signed-profile-picture', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path: original })
    })
    if (!response.ok) return null
    const result = await response.json()
    const signed = result?.signedUrl
    return typeof signed === 'string' && signed.length > 0 ? signed : null
  } catch {
    return null
  }
}
